import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface DiffNavigationProps {
  currentIndex: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function DiffNavigation({
  currentIndex,
  total,
  onPrevious,
  onNext,
}: DiffNavigationProps) {
  return (
    <div className="flex items-center gap-2 justify-center">
      <Button
        variant="outline"
        size="sm"
        onClick={onPrevious}
        disabled={currentIndex === 0}
      >
        <ChevronLeft className="h-4 w-4 mr-1" />
        Previous
      </Button>
      <span className="text-sm text-muted-foreground px-2">
        {currentIndex + 1} / {total || 1}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={onNext}
        disabled={currentIndex >= total - 1}
      >
        Next
        <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
}
